import {
  isActivationBlocked,
  isTargetOwnedBy,
  filterTargetOptions,
  targetRouteHandler
} from '@/helpers'
import store from '@/store'
import { SIGN_OUT } from '@/store/modules/auth/constants'
import {
  INIT_WORKBENCH_FOR_TARGET,
  SHOW_TARGET_HISTORY_PANEL,
} from '@/views/workbenchCanvas/store/WorkbenchWCanvasSlotActionsGenerator'
import { ResizeSensor } from 'css-element-queries'
import {ROUTE_BACK} from '@/appLogic/route/store/actions'
import { TARGET_TYPE, ACTIVATION_STATUS } from '@/appLogic/targets/Constants'
import { deleteTarget } from '@/api'

const commonMixins = {
  computed: {
    username () {
      return this.$store.getters.username
    },
    currentTarget () {
      return this.$store.getters.currentTarget
    },
    loading () {
      return this.$store.getters.loading
    },
    toolbarMetrics () {
      return this.$store.getters.metrics
    },
    targetName () {
      return this.$store.getters.targetName
    },
    activated () {
      return this.$store.getters.isTargetActivated
    },
    activateLabel () {
      return this.currentTarget && this.currentTarget.target === TARGET_TYPE.SD ? 'Activate' : 'Generate Estimate'
    },
    dynamicHeaderMenu () {
      let headerMenu = this.headerMenu
      if (this.headerMenu.length === 0) {
        headerMenu = []
      } else if (this.currentTarget.activated || !isTargetOwnedBy(this.currentTarget, this.username)) {
        headerMenu = filterTargetOptions(headerMenu, [this.activateLabel, 'Edit'])
      } else if (this.currentTarget.activation_status === 'ACTIVATED') {
        headerMenu = filterTargetOptions(headerMenu, ['Edit'])
      } else if (isActivationBlocked(this.currentTarget.target)) {
        headerMenu = filterTargetOptions(headerMenu, [this.activateLabel])
      }
      if (!this.hasPermissionToGenerateEstimate()) {
        headerMenu = filterTargetOptions(headerMenu, [this.activateLabel])
      }
      return headerMenu
    },
    headerMenu () {
      const targetType = this.currentTarget && this.currentTarget.target
      const targetId = this.currentTarget && this.currentTarget.id
      const currentUsername = this.username
      const target = this.currentTarget

      return targetId && targetType && currentUsername ? [
        {
          name: 'My Targets',
          value: {
            action () {
              this.$store.dispatch(ROUTE_BACK)
            }
          }
        }, {
          name: 'Edit',
          value: {
            action () {
              targetRouteHandler('SETTINGS', target)
            }
          }
        }, {
          name: targetType === TARGET_TYPE.SD ? 'Activate' : 'Generate Estimate',
          value: {
            action () {
              targetRouteHandler('ACTIVATE', target)
            }
          }
        }, {
          name: 'Duplicate',
          value: {
            action () {
              targetRouteHandler('DUPLICATE', target)
            }
          }
        }, {
          name: 'History',
          value: {
            action () {
              this.$store.dispatch(SHOW_TARGET_HISTORY_PANEL, true)
            }
          }
        }, {
          name: 'Sign Out',
          value: {
            action () {
              store.dispatch(SIGN_OUT)
              this.$auth.signOut()
            }
          }
        }
      ] : []
    }
  },
  methods: {
    hasPermissionToGenerateEstimate () {
      return true
      // return this.$store.getters.permissions.canGenerateForcasts()
    },
    initWorkbenchForTarget (id) {
      this.$store.dispatch(INIT_WORKBENCH_FOR_TARGET, id)
    }
  },
  created () {
    this.initWorkbenchForTarget(this.$route.params.id)

    window.onbeforeunload = (e) => {
      if (this.$store.getters.isSaveEnabled) {
        return 'Are you sure?'
      }
    }
  },
  beforeRouteUpdate (to, from, next) {
    this.fetchTargetData(to.params.id)
  },
  beforeRouteLeave (to, from, next) {
    // There are no unsaved changes
    if (!this.$store.getters.targetDefinitionHasChanged) {
      if (this.currentTarget.activation_status === ACTIVATION_STATUS.DRAFT) { // need to autodelete LAS/AD target if leaving workbench in Draft status with no changes
        deleteTarget(this.currentTarget).then(function (response) {
          console.log(response)
        }).catch(function (reason) {
          console.log(reason)
        })
      }

      next()
      return
    }
    this.$refs.confirmModal.open(next)
  },
  beforeDestroy () {
    ResizeSensor.detach(this.canvasEl)
  },
  destroyed () {
    document.querySelector('html').classList.remove('workbench-resize')
    window.onbeforeunload = null
  }
}

export default commonMixins



// WEBPACK FOOTER //
// ./src/app/views/workbench/mixins/CommonWorkbenchMixins.js